module.exports = __webpack_public_path__ + "09_hair_black.2d1e23b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/09_hair_black.png
// module id = j/XM
// module chunks = 0